<template>
  <ff-file-upload
    :action="upload"
    :text="text || 'Upload a File'"
    :accept="'*'"
    :type="type"
    :menu="menu"
  />
</template>

<script>
import { mapState } from 'vuex'

import { uploadFile } from '../../helpers/storage'

import FFFileUpload from '../DesignSystem/FFFileUpload'

export default {
  name: 'file-upload',
  props: [
    'text',
    'type',
    'params',
    'menu'
  ],
  components: {
    'ff-file-upload': FFFileUpload
  },
  data () {
    return {
    }
  },
  methods: {
    async upload (e) {
      this.$emit('started')
      if (e.target.files && e.target.files.length) {
        let url = await uploadFile(e.target.files[0], this.channel_id)
        if (!this.params) return this.$emit('upload', url)
        return this.$emit('upload', url, this.params)
      }
    }
  },
  computed: {
    ...mapState(['channel_id'])
  }
}
</script>
